module.exports = __webpack_public_path__ + "img/Zakinthos.b4749720.png";